import {each} from "lodash";


export const slotName = (slot) => {
    if(slot===null) return null;
    const levels = ['area', 'zone', 'aisle', 'side', 'col', 'level', 'position'];
    let name = '';
    each(levels, (level) => {
        if(slot[level]!==null) {
            if(name.length>0)name += ' - ';
            name += slot[level];
        }
    });
    return name;
}


export const assetName = (asset) => {
    let name = asset === null ? null : asset.registration;
    return name;
}